<div class="container">

  <div class="toggle-bar" (click)="togglePanel()"
       [ngClass]="{
        'toggle-bar-collapsed': leftSideMode==='collapsed',
        'toggle-bar-accent': leftSideMode==='expanded',
        }">
    @if (leftSideMode==='collapsed') {
      <mat-icon>keyboard_double_arrow_right</mat-icon>
    }
    @if (leftSideMode==='expanded') {
      <mat-icon>keyboard_double_arrow_left</mat-icon>
    }
  </div>

  <div style="width: 100%">
    @if (!siteSelected && ((organizationCount$ | async) ?? 0) > 1) {
      <div class="header">
        @if (leftSideMode === sideModeEnum.MODE_EXPANDED && (organization$| async); as organization) {
          <div >{{organization.name}}</div>
        }
      </div>
    }

    @if (!siteSelected && leftSideMode === sideModeEnum.MODE_EXPANDED) {
      <div>
        @if (!displaySitesFilters) {
          <site-list-panel></site-list-panel>
        }
        @if (displaySitesFilters) {
          <site-filters-panel></site-filters-panel>
        }
      </div>
    }

    @if (siteSelected && leftSideMode === sideModeEnum.MODE_EXPANDED) {
      <site-details-panel (close)="close($event)"></site-details-panel>
    }
  </div>


</div>
